import React from 'react';
import { observer } from 'mobx-react';
import Box from '@mui/material/Box';
import HeaderContainer from '@ui/features/Header/Header.container';
import SupportContainer from '@ui/features/Support/Support.container';
import MainContainer from '@ui/features/Main/Main.container';
import DeviceTelemetryContainer from '@ui/features/Device-telemetry/Device-telemetry.container';
import withPage from '@ui/HOCs/withPage';
import withSideBar from '@ui/HOCs/withSideBar';
import withSection from '@ui/HOCs/withSection';
import withSections from '@ui/HOCs/withSections';
import { lang } from '@lang/interfaces/lang';

interface IProps extends JSX.IntrinsicAttributes {
    lang: lang;
}

const SideBar = withSideBar(SupportContainer);
const Map = withSection(MainContainer);
const DeviceTelemetry = withSection(DeviceTelemetryContainer);
const Support = withSection(SupportContainer);
const SectionsContent: React.FC<IProps> = () => {
    return (
        <>
            <Map />
            <DeviceTelemetry />
        </>
    );
};
const Sections = withSections(SectionsContent);

const Page: React.FC<IProps> = ({ lang }: IProps) => {
    return (
        <>
            <HeaderContainer />
            <Box className="main" component="main">
                <SideBar />
                <Sections lang={lang} />
            </Box>
        </>
    );
};

const WrappedPage = withPage(Page, 'main__wrap', 'support');

const SupportPage = observer(WrappedPage);

export default SupportPage;
